import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Box } from 'rebass';
import { useHistory, useLocation } from 'react-router-dom';
import { HiOutlineUsers } from 'react-icons/hi';
import { MdOutlineMenuBook } from 'react-icons/md';
import { FT_COLORS } from '../theme';

// Bottom tab bar: Family | Page Preview (mobile only — desktop uses the top bar).
const TABS = [
  { key: 'family', label: 'Family', icon: HiOutlineUsers },
  { key: 'preview', label: 'Page Preview', icon: MdOutlineMenuBook },
];

const BottomTabs = ({ baseRoute, active }) => {
  const { replace } = useHistory();
  const { search } = useLocation();

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      bg="white"
      py={2}
      sx={{ borderTop: '1px solid', borderColor: FT_COLORS.rowBorder, gap: '8px' }}
    >
      {TABS.map(({ key, label, icon: Icon }) => {
        const isActive = active === key;
        return (
          <Flex
            key={key}
            as="button"
            type="button"
            alignItems="center"
            px={3}
            py={1}
            onClick={() => replace(`${baseRoute}${key === 'preview' ? '/preview' : ''}${search}`)}
            sx={{
              gap: '6px',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '100px',
              bg: isActive ? FT_COLORS.surface : 'transparent',
              color: isActive ? FT_COLORS.primary : '#64748B',
            }}
          >
            <Box as={Icon} size={18} />
            <Text fontFamily="Poppins" fontWeight={500}  fontSize="16px">
              {label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

BottomTabs.propTypes = {
  baseRoute: PropTypes.string.isRequired,
  active: PropTypes.oneOf(['family', 'preview']).isRequired,
};

export default BottomTabs;
